import G2CompanyLookup from './G2CompanyLookup'

export default G2CompanyLookup
